export default {
  "a84b6197-3dcc-52f4-a325-6a44157e27d4": "Prototype Confirmation",
  "a980cca4-ca1b-5954-9d95-d784a5008571": "Manufacturer's Declaration",
  "1311341d-f702-51f3-ad44-e26ff3d677a1": "Certificate",
};
